/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-14 17:56:29
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-14 18:02:28
 */
import React, { useState } from 'react';
import MedalBtn from '@src/assets/medal.svg';
import MedalBtnAct from '@src/assets/medal-act.svg';
import { Tooltip } from 'antd';
import './Medal.less';

/**
 * `className`: 组件class名
 * `size`: item大小：超大'huge'大'large'小'small'
 * `img`: 勋章图片
 * `onClick`: 点击
 * `title`: 划入展示获取条件
 * `disableImg`: 未获得的徽章图片
 */
export interface IMedalProps {
  className?: string;
  size?: 'huge' | 'large' | 'small';
  img?: string;
  onClick?: () => void;
  title?: string;
  disableImg?: string;
}
type Props = IMedalProps;

export function Medal(props: Readonly<Props>) {
  const { className = '', size = 'small', onClick, img, title, disableImg } = props;
  const isBtn = !img;
  const [isHover, setIshover] = useState(false);

  const handleClick = () => {
    onClick && onClick();
  };

  const mouseEnter = () => {
    setIshover(true);
  };

  const mouseLeave = () => {
    setIshover(false);
  };

  return (
    <Tooltip title={title} overlayClassName="ant-tooltip-white">
      <div
        className={`k-common-medal ${className} ${size === 'large' ? 'medal-large' : ''}`}
        onClick={handleClick}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        {isBtn && <div className="medal__btn" />}
        {disableImg &&
          (isHover ? (
            <img src={img} alt="" className="medal__img" />
          ) : (
            <img src={disableImg} alt="" className="medal__img" />
          ))}
        {!isBtn && !disableImg && <img src={img} alt="" className="medal__img" />}
      </div>
    </Tooltip>
  );
}

export default Medal;
